import React, {useContext} from "react";
import {useHistory} from 'react-router-dom'
import {NavBarContext} from "./NavBarContext";
import {ServerContext} from "../../serverContext/ServerProvider";

export const NavBar = () => {
    const {selectedPage, setSelectedPage} = useContext(NavBarContext)
    const history = useHistory();
    const {goods} = useContext(ServerContext)
    const items = [{title: 'Main', link: '/admin'}].concat(goods.map(good => {
        return {
            title: good.name,
            link: '/admin' + good.link
        }
    })).concat([{title: 'Orders', link: '/admin/orders'}])

    const clickHandler = (link) => {
        setSelectedPage(link)
        history.push(link)
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                    {items.map(item => (
                        <li key={item.link}
                            onClick={() => clickHandler(item.link)}
                            className={selectedPage === item.link ? 'nav-item active' : 'nav-item'}>
                            {item.title}
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    )
}